export default "__VITE_ASSET__0jJWoEkS__"